import { reviewsApi } from "../store/api/reviewsApi";
import { runQuery } from "../store/api/runtime";

export async function getReviews(userId: string): Promise<unknown> {
  return runQuery(reviewsApi.endpoints.getReviews.initiate, userId);
}
